// Change order

function moveContainer(selector, element, direction) {
  if (app.movingMultipleTextfieldContainer) {
    return;
  }

  var container = $(element).parents(selector);
  var containerSwap = container[direction == 'up' ? 'prev' : 'next']();

  if (!containerSwap || !containerSwap.length) {
    return;
  }

  formUserInput = true;
  app.movingMultipleTextfieldContainer = true;

  // TODO following could be a shared function, see file-input.js

  var containerTop = container.offset().top;
  var containerHeight = container.outerHeight();
  var containerSwapTop = containerSwap.offset().top;
  var containerSwapHeight = containerSwap.outerHeight();

  if (direction == 'up') {
    var differenceTop = containerTop - containerSwapTop;
  } else {
    var differenceTop =
      containerTop - containerSwapTop - containerSwapHeight + containerHeight;
  }

  container.animate(
    {
      y: differenceTop
    },
    {
      duration: 350,
      step: function (val) {
        container.css('transform', `translateY(${val * -1}px)`);
      },
      complete: function () {
        container.removeAttr('style');
      }
    }
  );

  if (direction == 'up') {
    var differenceSwapTop =
      containerTop - containerSwapTop - containerSwapHeight + containerHeight;
  } else {
    var differenceSwapTop = containerTop - containerSwapTop;
  }

  containerSwap.animate(
    {
      y: differenceSwapTop
    },
    {
      duration: 350,
      step: function (val) {
        containerSwap.css('transform', `translateY(${val}px)`);
      },
      complete: function () {
        containerSwap.removeAttr('style');
        container[direction == 'up' ? 'insertBefore' : 'insertAfter'](
          containerSwap
        );
        app.movingMultipleTextfieldContainer = false;

        if (container.data('initTinyMCY')) {

          var initTinyMCY = container.data('initTinyMCY');
          container.find('.tox-tinymce').remove();

          const originalTextarea = $(initTinyMCY.selector);
          const newTextarea = $('<textarea data-value="content" data-form-value data-check-unload-event  aria-hidden="true" />');
          newTextarea.val(originalTextarea.val());
          newTextarea.insertAfter(originalTextarea);
          originalTextarea.remove();

          var id = id || uuidv4();

          container.attr('data-id', id);
          container.attr('data-editor-id', 'editor-custom_content_1-' + id);

          initTinyMCY.id = id;
          initTinyMCY.selector = '.input__wrapper[data-form-input="custom_content_1"] .title-textarea-html-list__container[data-id="' + id + '"] textarea[data-form-value]';

          container.data('initTinyMCY', initTinyMCY);

          initHTMLTextareaTinymce(
						initTinyMCY.id,
						initTinyMCY.selector,
						initTinyMCY.minHeight,
						initTinyMCY.placeholder
					);
        }
      }
    }
  );
}
